const STRINGS = {
  paymentTitle: {
    en: (strings?: Array<string>) => `Checkout`,
    fr: (strings?: Array<string>) => `Paiement`,
  },
  tokenizationTitle: {
    en: (strings?: Array<string>) => 'Save Credit Card',
    fr: (strings?: Array<string>) => 'Sauvegarder la carte de crédit',
  },
  clientDetailsHeader: {
    en: (strings?: Array<string>) => 'Client Information',
    fr: (strings?: Array<string>) => 'Information du Client',
  },
  billingDetailsHeader: {
    en: (strings?: Array<string>) => 'Billing Information',
    fr: (strings?: Array<string>) => 'Informations sur la facturation',
  },
  billingDetailsSelector: {
    en: (strings?: Array<string>) => 'Billing Details Same as Client Details',
    fr: (strings?: Array<string>) =>
      'Détails de la facturation identiques aux détails du client',
  },
  billingDetailsEdit: {
    en: (strings?: Array<string>) => 'Edit Billing Details',
    fr: (strings?: Array<string>) => 'Modifier les détails de la facturation',
  },
  tokenizationSuccess: {
    en: (strings?: Array<string>) => 'Success',
    fr: (strings?: Array<string>) => 'Succès',
  },
  tokenizationWait: {
    en: (strings?: Array<string>) => 'Please wait...',
    fr: (strings?: Array<string>) => 'S`il vous plaît, attendez...',
  },
  creditCardDetailsHeader: {
    en: (strings?: Array<string>) => 'Credit Card',
    fr: (strings?: Array<string>) => 'Carte de crédit',
  },
  creditCardDetailsCardNumber: {
    en: (strings?: Array<string>) => 'Card Number',
    fr: (strings?: Array<string>) => 'Numéro de la carte ',
  },
  creditCardDetailsExpiryDate: {
    en: (strings?: Array<string>) => 'Expiry (MM/YY)',
    fr: (strings?: Array<string>) => 'Expiration (mm/aa)',
  },
  creditCardDetailsCcv: {
    en: (strings?: Array<string>) => 'CVV',
    fr: (strings?: Array<string>) => 'CVV',
  },
  agreementsHeader: {
    en: (strings?: Array<string>) => 'Agreements',
    fr: (strings?: Array<string>) => 'Accords',
  },
  clearButton: {
    en: (strings?: Array<string>) => 'Clear',
    fr: (strings?: Array<string>) => 'Effacer',
  },
  submitButton: {
    en: (strings?: Array<string>) => 'Submit',
    fr: (strings?: Array<string>) => 'Soumettre',
  },
  submitWait: {
    en: (strings?: Array<string>) => 'Loading...',
    fr: (strings?: Array<string>) => 'Chargement...',
  },
  formRequired: {
    en: (strings?: Array<string>) => `${strings?.[0] || 'field'} is required`,
    fr: (strings?: Array<string>) => `${strings?.[0] || 'le champ'} est requis`,
  },
  formInvalid: {
    en: (strings?: Array<string>) => `${strings?.[0] || 'field'} is invalid`,
    fr: (strings?: Array<string>) =>
      `${strings?.[0] || 'le champ'} est invalide`,
  },
  formInPast: {
    en: (strings?: Array<string>) =>
      `${strings?.[0] || 'field'} must be in the future`,
    fr: (strings?: Array<string>) =>
      `${strings?.[0] || 'le champ'} doit être dans le futur`,
  },
  formDisclaimerRequired: {
    en: (strings?: Array<string>) => 'Please accept the disclaimer to continue',
    fr: (strings?: Array<string>) =>
      'Veuillez accepter la clause de non-responsabilité pour continuer',
  },
  paymentDetailsHeader: {
    en: (strings?: Array<string>) => 'Payment Details',
    fr: (strings?: Array<string>) => 'Détails du paiement',
  },
  paymentScheduleHeader: {
    en: (strings?: Array<string>) => 'Payment Schedule',
    fr: (strings?: Array<string>) => 'Calendrier de paiement',
  },
  paymentScheduleChooseLabel: {
    en: (strings?: Array<string>) => 'Choose Payment Plan:',
    fr: (strings?: Array<string>) => 'Choisir un plan de paiement :',
  },
  paymentScheduleInFullOption: {
    en: (strings?: Array<string>) => 'Pay in Full - Process payment today',
    fr: (strings?: Array<string>) => 'Payer en totalité - Traiter le paiement aujourd’hui',
  },
  // PPD-629 — future single payment
  scheduleInFullOption: {
    en: (strings?: Array<string>) => 'Schedule Payment in Full - Pay on a future date',
    fr: (strings?: Array<string>) => 'Planifier le paiement intégral - Payer à une date future',
  },
  scheduleDateLabel: {
    en: (strings?: Array<string>) => 'Choose Payment Date:',
    fr: (strings?: Array<string>) => 'Choisir la date de paiement :',
  },
  scheduleDateRequired: {
    en: (strings?: Array<string>) => 'Please choose a date for your scheduled payment.',
    fr: (strings?: Array<string>) => 'Veuillez choisir une date pour votre paiement planifié.',
  },
  paymentScheduleLoadFailed: {
    en: (strings?: Array<string>) => 'Could not load payment plans. Pay in Full is available.',
    fr: (strings?: Array<string>) => 'Impossible de charger les plans de paiement. Le paiement intégral est disponible.',
  },
  paymentScheduleSubHeader: {
    en: (strings?: Array<string>) => 'Payment Schedule:',
    fr: (strings?: Array<string>) => 'Calendrier de paiement :',
  },
  paymentScheduleColPayment: {
    en: (strings?: Array<string>) => 'Payment',
    fr: (strings?: Array<string>) => 'Paiement',
  },
  paymentScheduleColDueDate: {
    en: (strings?: Array<string>) => 'Due Date',
    fr: (strings?: Array<string>) => 'Date d’échéance',
  },
  paymentScheduleColAmount: {
    en: (strings?: Array<string>) => 'Amount',
    fr: (strings?: Array<string>) => 'Montant',
  },
  paymentSchedulePaymentLabel: {
    en: (strings?: Array<string>) => `Payment ${strings?.[0] ?? ''}`,
    fr: (strings?: Array<string>) => `Paiement ${strings?.[0] ?? ''}`,
  },
  paymentScheduleFeeChangeNote: {
    en: (strings?: Array<string>) =>
      'Note: Fees are in addition and subject to change if the fee structure changes during the plan period.',
    fr: (strings?: Array<string>) =>
      'Remarque : les frais s’ajoutent et peuvent changer si la structure des frais est modifiée pendant la durée du plan.',
  },
  contactInformationHeader: {
    en: (strings?: Array<string>) => 'Contact Information',
    fr: (strings?: Array<string>) => 'Contact',
  },
  bankAccountHeader: {
    en: (strings?: Array<string>) => 'Bank Account',
    fr: (strings?: Array<string>) => 'Compte bancaire',
  },
  institutionNumber: {
    en: (strings?: Array<string>) => 'Institution Number (3 digits)',
    fr: (strings?: Array<string>) =>
      'Numéro de l`institution financière (3 chiffres)',
  },
  transitNumber: {
    en: (strings?: Array<string>) => 'Transit Number (5 digits)',
    fr: (strings?: Array<string>) =>
      'Numéro de transit de la succursale (5 chiffres)',
  },
  accountNumber: {
    en: (strings?: Array<string>) => 'Account Number (up to 14 digits)',
    fr: (strings?: Array<string>) =>
      'Numéro de compte bancaire (jusqu`à 14 chiffres)',
  },
  electronicSignatureHeader: {
    en: (strings?: Array<string>) => 'Electronic Signature',
    fr: (strings?: Array<string>) => 'Signature électronique',
  },
  acknowledgementsHeader: {
    en: (strings?: Array<string>) => 'Agreements',
    fr: (strings?: Array<string>) => 'Accords',
  },
};

export { STRINGS };
